import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function CancelPage() {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect after 2 seconds
    const timer = setTimeout(() => {
      navigate("/");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="flex h-screen items-center justify-center bg-red-50">
      <div className="p-6 rounded-2xl shadow-lg bg-white text-center">
        <h1 className="text-2xl font-bold text-red-600 mb-2">Payment Canceled</h1>
        <p className="text-gray-600">Redirecting you back to the homepage...</p>
      </div>
    </div>
  );
}
